<template>
    <div
        v-qa="'splash-screen'"
        class="splash-screen"
        :class="classSplashScreen"
    >
        <img
            class="logo"
            :class="classLogo"
            alt="Taylor & Hart"
            src="@/assets/taylor-and-hart-logo-alt.svg"
            loading="lazy"
        />

        <LoadingAnimation />

        <slot></slot>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import LoadingAnimation from '@/components/ui/LoadingAnimation.vue'

const props = defineProps<{
    hideLogo?: boolean
    whiteBackground?: boolean
}>()

const classLogo = computed(() => ({
    hidden: props.hideLogo,
}))

const classSplashScreen = computed(() => ({
    'white-background': props.whiteBackground,
}))
</script>

<style lang="scss" scoped>
.splash-screen {
    position: absolute;
    background: $stone-2;
    display: flex;
    width: 100%;
    height: 100vh;
    align-items: center;
    justify-content: center;
    flex-flow: column;
    opacity: 1;
    animation: fade-in ease-in 0.5s;

    &.white-background {
        background: $white;
    }

    .logo {
        width: 300px;
        max-width: 70%;

        &.hidden {
            opacity: 0;
        }
    }
}

@keyframes fade-in {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}
</style>
